import type { ParsedChapter } from './parseChaptersWebVtt';

export type ChapterHit = { chapter: ParsedChapter; index: number };

/** Chapter that contains `time`, using open-ended last segment when end ≤ start. */
export function findChapterWithIndexAtTime(chapters: ParsedChapter[], time: number): ChapterHit | null {
  for (let i = 0; i < chapters.length; i++) {
    const ch = chapters[i];
    const next = chapters[i + 1];
    let end: number;
    if (ch.endTime > ch.startTime) {
      end = ch.endTime;
    } else if (next === undefined) {
      end = Number.POSITIVE_INFINITY;
    } else {
      end = next.startTime;
    }
    if (time >= ch.startTime && time < end) {
      return { chapter: ch, index: i };
    }
  }
  return null;
}

export function findChapterAtTime(chapters: ParsedChapter[], time: number): ParsedChapter | null {
  return findChapterWithIndexAtTime(chapters, time)?.chapter ?? null;
}

/** Formats seconds as H:MM:SS or M:SS for chapter labels. */
export function formatChapterTime(totalSeconds: number): string {
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return '0:00';
  const s = Math.floor(totalSeconds);
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  const sec = s % 60;
  const min = m % 60;
  if (h > 0) {
    return `${h}:${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  }
  return `${min}:${String(sec).padStart(2, '0')}`;
}
